import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as currentProductsState from '../employee-detail.reducer';
import * as currentProductsReducer from '../reducers/current-products.reducer';

export const getCurrentProducts = createSelector(
  currentProductsState.getCurrentProductsState,
  currentProductsReducer.getCurrentProductsResponse
);

export const getUpcomingProducts = createSelector(
  currentProductsState.getCurrentProductsState,
  currentProductsReducer.getUpcomingProductsResponse
);
